import { render } from "./TheFeedback.vue?vue&type=template&id=4af8757e"
import script from "./TheFeedback.vue?vue&type=script&lang=js"
export * from "./TheFeedback.vue?vue&type=script&lang=js"
script.render = render

export default script